import { CapturedHttpRequest } from '@reqshare/protocol';

export function formatCurl(request: CapturedHttpRequest): string {
  const parts: string[] = ['curl'];

  if (request.method !== 'GET') {
    parts.push(`-X ${request.method}`);
  }

  parts.push(`'${request.url}'`);

  for (const header of request.headers) {
    parts.push(`-H '${header.name}: ${header.value}'`);
  }

  if (request.body?.text) {
    parts.push(`-d '${request.body.text}'`);
  }

  return parts.join(' \\\n  ');
}
